import { produce } from 'immer';
import {
  ENCARGOS_CREACION_INICIALIZAR_SUCCESS,
  ENCARGOS_CREACION_ARTICULOS_ESTABLECER_A_LINEA,
  ENCARGOS_CREACION_ESTABLECER_PROPIEDAD_CABECERA,
  ENCARGOS_CREACION_ESTABLECER_CLIENTE,
  ENCARGOS_CREACION_ESTABLECER_GRADUACIONES,
  ENCARGOS_CREACION_MOSTRAR_GRADUACIONES,
  ENCARGOS_CREACION_OCULTAR_GRADUACIONES,
  ENCARGOS_CREACION_ESTABLECER_GRADUACION,
  ENCARGOS_CREACION_ARTICULOS_BORRAR_LINEA,
  ENCARGOS_CREACION_APLICAR_DESCUENTO,
  ENCARGOS_CREACION_MODIFICAR_PRECIO_LINEA,
  ENCARGOS_CREACION_ARTICULOS_AÑADIR_A_LINEA_CON_FORMA,
  ENCARGOS_CREACION_SET_LENTES,
  INICIAR_VENTANA_ADD_SUPLS,
  ENCARGOS_CREACION_SET_VISIBLE_VENTANA_ADD_SUPLS,
  ENCARGOS_CREACION_ARTICULOS_AGREGAR_LINEA,
  ENCARGOS_CREACION_ARTICULOS_MODIFICAR_UNIDADES,
  ENCARGOS_CREACION_BORRAR_DESCUENTO,
  ENCARGOS_CREACION_EXPANDIR_ENCARGO,
  ENCARGOS_CREACION_CONTRAER_ENCARGO,
  ENCARGOS_CREACION_ARTICULOS_MODIFICAR_NUMERO_LOTE,
  ENCARGOS_CREACION_GUARDAR_SUCCESS,
  ENCARGOS_CREACION_APLICAR_ERRORES_FORMULARIO,
  ENCARGOS_CREACION_ELIMINAR_CLIENTE,
  ENCARGOS_CREACION_SELECCIONAR_MONTURA_GAFA_GRADUADA, ENCARGOS_CREACION_ARTICULOS_TEMPORAL_CREAR_ESTABLECER_A_LINEA,
} from '../actions/constants/encargos.creador.constants';
import { findEncargoByUUID, findLineaFromEncargo } from '../../modules/encargos/lib/busquedas.lib';
import DetalleEncargoCreador from '../../modules/encargos/model/builder/DetalleEncargo.creador';
import DescuentoDetalleBuilder from '../../modules/encargos/model/builder/DescuentoDetalleBuilder';
import GraduacionesClienteEncargoBuilder
  from '../../modules/encargos/model/builder/GraduacionesClienteEncargoBuilder.creador';
import InfoLentesBuilder from '../../modules/encargos/model/builder/InfoLentes.creador';

const initialState = {
  inicializado: false,
  esPresupuesto: null,
  promocion: null,
  tiendaId: null,
  encargos: [],
};

export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ENCARGOS_CREACION_INICIALIZAR_SUCCESS: {
      const {
        encargos, promocion, tiendaId, titulo,
      } = payload;
      return {
        tiendaId,
        esPresupuesto: false,
        encargos,
        promocion,
        titulo,
        inicializado: true,
      };
    }
    case ENCARGOS_CREACION_ESTABLECER_PROPIEDAD_CABECERA: {
      const { encargoUUID, nombre, valor } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID === uuid);
      if (encargoAfectado !== undefined) {
        encargoAfectado.cabecera[nombre] = valor;
      }
      return draft;
    }
    case ENCARGOS_CREACION_ESTABLECER_CLIENTE: {
      const { encargoUUID, cliente } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID === uuid);

      if (encargoAfectado !== undefined) {
        const {
          id, nombreCompleto, tiendaId, fechaUltimaGraduacionOptometrica, fechaUltimaGraduacionContactologica, codigoGrupoCliente,
        } = cliente;
        encargoAfectado.cabecera.cliente.id = id;
        encargoAfectado.cabecera.cliente.nombreCompleto = nombreCompleto;
        encargoAfectado.cabecera.cliente.tiendaId = tiendaId;
        encargoAfectado.cabecera.cliente.fechaUltimaGraduacionOptometrica = fechaUltimaGraduacionOptometrica;
        encargoAfectado.cabecera.cliente.fechaUltimaGraduacionContactologica = fechaUltimaGraduacionContactologica;
        encargoAfectado.cabecera.cliente.fechaUltimaGraduacionContactologica = fechaUltimaGraduacionContactologica;
        encargoAfectado.cabecera.cliente.codigoGrupoCliente = codigoGrupoCliente;
        encargoAfectado.cabecera.cliente.graduaciones = GraduacionesClienteEncargoBuilder.build({ mostrar: false });
      }
      return draft;
    }
    case ENCARGOS_CREACION_ELIMINAR_CLIENTE: {
      const { encargoUUID, cliente } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID === uuid);

      if (encargoAfectado !== undefined) {
        encargoAfectado.cabecera.cliente.id = null;
        encargoAfectado.cabecera.cliente.nombreCompleto = null;
        encargoAfectado.cabecera.cliente.tiendaId = null;
        encargoAfectado.cabecera.cliente.fechaUltimaGraduacionOptometrica = null;
        encargoAfectado.cabecera.cliente.fechaUltimaGraduacionContactologica = null;
        encargoAfectado.cabecera.cliente.fechaUltimaGraduacionContactologica = null;
        encargoAfectado.cabecera.cliente.codigoGrupoCliente = null;
        encargoAfectado.cabecera.cliente.graduaciones = GraduacionesClienteEncargoBuilder.build({ mostrar: false });
      }
      return draft;
    }
    case ENCARGOS_CREACION_ESTABLECER_GRADUACIONES: {
      const { encargoUUID, graduaciones } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID === uuid);
      if (encargoAfectado !== undefined) {
        const { optometricas, contactologicas } = graduaciones;
        encargoAfectado.cabecera.cliente.graduaciones.optometricas.listado = optometricas;
        encargoAfectado.cabecera.cliente.graduaciones.contactologicas.listado = contactologicas;
        if (optometricas && optometricas.length > 0) {
          const optometricaSeleccionada = optometricas[0];
          encargoAfectado.cabecera.cliente.graduaciones.optometricas.seleccion = {
            ...optometricaSeleccionada,
            tiendaId: optometricaSeleccionada.tienda_id,
          };
        }
        if (contactologicas && contactologicas.length > 0) {
          const contactologicaSeleccionada = contactologicas[0];
          const { id, codigo_tienda: tiendaId } = contactologicaSeleccionada;
          encargoAfectado.cabecera.cliente.graduaciones.contactologicas.seleccion = {
            id,
            tiendaId,
          };
        }
      }
      return draft;
    }
    case ENCARGOS_CREACION_MOSTRAR_GRADUACIONES: {
      const { encargoUUID } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID === uuid);
      if (encargoAfectado !== undefined) {
        encargoAfectado.cabecera.cliente.graduaciones.mostrar = true;
      }
      return draft;
    }
    case ENCARGOS_CREACION_OCULTAR_GRADUACIONES: {
      const { encargoUUID } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID === uuid);
      if (encargoAfectado !== undefined) {
        encargoAfectado.cabecera.cliente.graduaciones.mostrar = false;
      }
      return draft;
    }
    case ENCARGOS_CREACION_ESTABLECER_GRADUACION: {
      const { encargoUUID, graduacionId, tipo } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID === uuid);
      if (encargoAfectado !== undefined) {
        const { optometricas, contactologicas } = encargoAfectado.cabecera.cliente.graduaciones;
        if (tipo === 'optometrica') {
          if (optometricas) {
            const { listado } = optometricas;
            if (listado && listado.length > 0) {
              const optometrica = listado.find(e => e.id === graduacionId);
              if (optometrica) {
                const { id, tienda_id: tiendaId } = optometrica;
                optometricas.seleccion = {
                  id,
                  tiendaId,
                };
              }
            }
          }
        } else if (contactologicas) {
          const { listado } = contactologicas;
          if (listado && listado.length > 0) {
            const contactologica = listado.find(e => e.id === graduacionId);
            if (contactologica) {
              const { id, codigo_tienda: tiendaId } = contactologica;
              contactologicas.seleccion = {
                id,
                tiendaId,
              };
            }
          }
        }
      }
      return draft;
    }

    case ENCARGOS_CREACION_ARTICULOS_ESTABLECER_A_LINEA: {
      const { encargoUUID, linea, articulo } = payload;
      const { encargos } = draft;
      const lineaAfectada = findLineaFromEncargo({ encargos, uuid: encargoUUID, linea });
      const {
        id, descripcion, codigo_tipo: codigoTipo, pvp,
      } = articulo;
      if (lineaAfectada) {
        lineaAfectada.articulo = {
          id,
          descripcion,
          codigoTipo,
          pvp: parseFloat(pvp),
        };
        lineaAfectada.descuento = DescuentoDetalleBuilder.build();
        lineaAfectada.unidades = 1;
        lineaAfectada.descripcion = descripcion;
        lineaAfectada.precio = parseFloat(pvp);
      } else {
        const encargoAfectado = findEncargoByUUID({ encargos, uuid: encargoUUID });
        if (encargoAfectado) {
          const { detalles } = encargoAfectado;
          const detalle = DetalleEncargoCreador.build({
            unidades: 1,
            linea: detalles.length + 1,
            cdgtipo: codigoTipo,
            descripcion,
          });
          detalle.articulo = articulo;
          detalle.descuento = DescuentoDetalleBuilder.build();
          detalle.precio = parseFloat(pvp);
          detalles.push(detalle);
        }
      }
      return draft;
    }
    case ENCARGOS_CREACION_ARTICULOS_TEMPORAL_CREAR_ESTABLECER_A_LINEA: {
      const { encargoUUID} = payload;
      const { encargos } = draft;
      const encargoAfectado = findEncargoByUUID({ encargos, uuid: encargoUUID });
      encargoAfectado.detallesTemporales.forEach((detalleTemp) => {
        let lineaAfectada = findLineaFromEncargo({ encargos, uuid: encargoUUID, linea: detalleTemp.linea });
        if (lineaAfectada) {
          lineaAfectada = detalleTemp;
        } else {
          encargoAfectado.detalles.push(detalleTemp);
        }
      });
      return draft;
    }
    case ENCARGOS_CREACION_SELECCIONAR_MONTURA_GAFA_GRADUADA: {
      const { encargoUUID, linea, articulo } = payload;
      const { encargos } = draft;
      const encargoAfectado = findEncargoByUUID({ encargos, uuid: encargoUUID });
      if (encargoAfectado) {
        const {
          id, descripcion, codigo_tipo: codigoTipo, pvp,
        } = articulo;
        encargoAfectado.detallesTemporales = [];
        const detalle = DetalleEncargoCreador.build({
          unidades: 1,
          linea: encargoAfectado.detalles.length + 1,
          cdgtipo: codigoTipo,
          descripcion,
        });
        detalle.articulo = {...articulo, codigoTipo};
        detalle.descuento = DescuentoDetalleBuilder.build();
        detalle.precio = parseFloat(pvp);
        encargoAfectado.detallesTemporales.push(detalle);
      }
      return draft;
    }
    case ENCARGOS_CREACION_ARTICULOS_AÑADIR_A_LINEA_CON_FORMA: {
      const { encargoUUID, linea, datosForma } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID == uuid);
      if (encargoAfectado !== undefined) {
        const { detalles } = encargoAfectado;
        const lineaAfectada = detalles.find(detalle => detalle.linea == linea);
        if (lineaAfectada) {
          lineaAfectada.articulo.forma_oma_montura = datosForma.forma_oma_montura;
          lineaAfectada.articulo.fecha_modificacion_forma_oma = datosForma.fecha_modificacion_forma_oma;
          lineaAfectada.articulo.admite_biselado_forma_oma = datosForma.admite_biselado_forma_oma;
        }
      }
      return draft;
    }
    case ENCARGOS_CREACION_SET_LENTES: {
      const {
        encargoUUID, linea, lentes,
      } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID === uuid);
      for (let i = 0; i < lentes.length; i += 1) {
        const lente = lentes[i];
        const {
          catalogoDetalleId,
          catalogoId,
          color,
          pasillo,
          ojo,
          nombreCompleto,
          nombreLente,
          tGamaDescripcion,
          precio,
          costo,
          diametro,
          indice,
          proveedor,
          tarifaId,
          datosMontura,
          precioSinSuplementos,
          costoSinSuplementos,
          suplementos,
          descripcionCompleta,
        } = lente;
        const lineaAUsar = parseInt(linea, 10) + i;
        if (encargoAfectado !== undefined) {
          const { detalles } = encargoAfectado;
          const lineaAfectada = detalles.find(detalle => detalle.linea === lineaAUsar);
          const infoTrazadora = lente.info_trazadora ? lente.info_trazadora : null;
          const shapeData = infoTrazadora ? JSON.parse(infoTrazadora).SHAPE_DATA : null;
          const alturaFocalTrazadoraD = shapeData && shapeData.OCHT_R ? shapeData.OCHT_R : null;
          const alturaFocalTrazadoraI = shapeData && shapeData.OCHT_L ? shapeData.OCHT_L : null;
          const alturaFocalTrazadora = lente.ojo === 'izquierdo' ? alturaFocalTrazadoraI : alturaFocalTrazadoraD;
          const articulo = {
            id: lente.tGamaId,
            codigoTipo: 1,
            proveedor,
            tarifaId,
            descripcion: tGamaDescripcion || nombreCompleto,
            pvp: precio, // precio lente con suplementos
            pvo: costo, // precio lente con suplementos
            infoLente: InfoLentesBuilder.build({
              descripcion: nombreLente,
              pvp: precioSinSuplementos, // precio lente sin suplementos
              pvo: costoSinSuplementos, // costo lente
              info_trazadora: lente.info_trazadora,
              ojo,
              diametro,
              indice,
              material: lente.material.id,
              foco: lente.foco,
              esRx: lente.esRx,
              alturaFocal: alturaFocalTrazadora || lente.alturaFocal,
              datosMontura,
              suplementos: suplementos.map(e => ({
                ...e.suplemento, pvo: e.pvo, pvp: e.pvp, incluido: e.incluido === 1,
              })),
              estadistica: {
                catalogoDetalleId,
                miCatalogoId: catalogoId,
                colorDetalleId: color.id,
                tipoProgresivoId: pasillo.id,
              },
            }),
          };
          if (lineaAfectada) {
            lineaAfectada.articulo = articulo;
            lineaAfectada.descuento = DescuentoDetalleBuilder.build();
            lineaAfectada.descripcion = descripcionCompleta;
            lineaAfectada.unidades = 1;
            lineaAfectada.precio = precio; // precio lente + suplementos usando descuentos y otros. Precio del detalle del encargo
          } else {
            const encargoAfectado = findEncargoByUUID({ encargos, uuid: encargoUUID });
            if (encargoAfectado) {
              const { detalles } = encargoAfectado;
              const detalle = DetalleEncargoCreador.build({
                unidades: 1,
                linea: lineaAUsar,
                cdgtipo: articulo.codigoTipo,
                descripcion: descripcionCompleta,
              });
              detalle.articulo = articulo;
              detalle.descuento = DescuentoDetalleBuilder.build();
              detalle.precio = precio;
              detalles.push(detalle);
            }
          }
        }
      }
      return draft;
    }
    case ENCARGOS_CREACION_ARTICULOS_BORRAR_LINEA: {
      const { encargoUUID, linea } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID == uuid);
      if (encargoAfectado !== undefined) {
        const { detalles } = encargoAfectado;
        const lineaAfectada = detalles.find(detalle => detalle.linea == linea);
        if (lineaAfectada) {
          const { eliminable } = lineaAfectada;
          if (eliminable === true) {
            const detallesSinLineaAfectada = detalles.filter(detalle => detalle.linea !== linea);
            encargoAfectado.detalles = detallesSinLineaAfectada.map((detalle) => {
              let lineaDetalle = detalle.linea;
              if (lineaDetalle > linea) {
                lineaDetalle -= 1;
              }
              return {
                ...detalle,
                linea: lineaDetalle,
              };
            });
          } else {
            lineaAfectada.articulo = undefined;
            lineaAfectada.precio = undefined;
          }
        }
      }
      return draft;
    }
    case ENCARGOS_CREACION_APLICAR_DESCUENTO: {
      const { encargoUUID, linea, descuento } = payload;
      const { encargos } = draft;
      const lineaAfectada = findLineaFromEncargo({ encargos, uuid: encargoUUID, linea });
      if (lineaAfectada) {
        const { bonificacionVariable, bonificacionesEstaticas } = descuento;
        if (bonificacionesEstaticas.length > 0) {
          lineaAfectada.descuento.bonificacionesEstaticas = bonificacionesEstaticas;
        }
        const {
          precioAlza, cantidad, tipo, id,
        } = bonificacionVariable;
        lineaAfectada.descuento.bonificacionVariable.precioAlza = precioAlza;
        lineaAfectada.descuento.bonificacionVariable.cantidad = cantidad;
        lineaAfectada.descuento.bonificacionVariable.tipo = tipo;
        lineaAfectada.descuento.bonificacionVariable.id = id;
      }
      return draft;
    }
    case ENCARGOS_CREACION_BORRAR_DESCUENTO: {
      const { encargoUUID, linea } = payload;
      const { encargos } = draft;
      const lineaAfectada = findLineaFromEncargo({ encargos, uuid: encargoUUID, linea });
      if (lineaAfectada) {
        lineaAfectada.descuento = DescuentoDetalleBuilder.build();
      }
      return draft;
    }
    case ENCARGOS_CREACION_MODIFICAR_PRECIO_LINEA: {
      const { encargoUUID, linea, precio } = payload;
      const { encargos } = draft;
      const lineaAfectada = findLineaFromEncargo({ encargos, uuid: encargoUUID, linea });
      if (lineaAfectada) {
        lineaAfectada.precio = precio;
      }
      return draft;
    }
    case ENCARGOS_CREACION_ARTICULOS_AGREGAR_LINEA: {
      const { encargoUUID, agrupacion } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID == uuid);
      if (encargoAfectado !== undefined) {
        const { detalles } = encargoAfectado;
        let countDetalles = detalles.length;
        for (let i = 0; i < agrupacion.length; i += 1) {
          const cdgtipo = agrupacion[i];
          detalles.push(DetalleEncargoCreador.build({
            unidades: 1, linea: countDetalles + 1, cdgtipo,
          }));
          countDetalles += 1;
        }
      }
      return draft;
    }
    case INICIAR_VENTANA_ADD_SUPLS: {
      return { ...draft, ventanaAddSuplementos: { visible: true, datosVentana: payload } };
    }
    case ENCARGOS_CREACION_SET_VISIBLE_VENTANA_ADD_SUPLS: {
      const { visible } = payload;
      const { ventanaAddSuplementos } = draft;
      return {
        ...draft,
        ventanaAddSuplementos: { visible: payload, datosVentana: payload ? ventanaAddSuplementos.datosVentana : null },
      };
    }
    case ENCARGOS_CREACION_ARTICULOS_MODIFICAR_UNIDADES: {
      const { encargoUUID, linea, unidades } = payload;
      const { encargos } = draft;
      const lineaAfectada = findLineaFromEncargo({ encargos, uuid: encargoUUID, linea });
      if (lineaAfectada && unidades > 0) {
        lineaAfectada.unidades = unidades;
      }
      return draft;
    }
    case ENCARGOS_CREACION_EXPANDIR_ENCARGO: {
      const { encargoUUID } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID == uuid);
      encargoAfectado.expandido = true;
      return draft;
    }
    case ENCARGOS_CREACION_CONTRAER_ENCARGO: {
      const { encargoUUID } = payload;
      const { encargos } = draft;
      const encargoAfectado = encargos.find(({ uuid }) => encargoUUID == uuid);
      encargoAfectado.expandido = false;
      return draft;
    }
    case ENCARGOS_CREACION_ARTICULOS_MODIFICAR_NUMERO_LOTE: {
      const { encargoUUID, linea, numeroLote } = payload;
      const { encargos } = draft;
      const lineaAfectada = findLineaFromEncargo({ encargos, uuid: encargoUUID, linea });
      if (lineaAfectada) {
        lineaAfectada.numeroLote = numeroLote;
      }
      return draft;
    }
    case ENCARGOS_CREACION_GUARDAR_SUCCESS: {
      draft.inicializado = false;
      return draft;
    }
    case ENCARGOS_CREACION_APLICAR_ERRORES_FORMULARIO: {
      const { errores } = payload;
      const { encargos } = draft;
      Object.keys(errores).forEach((uuid) => {
        const erroresFormulario = errores[uuid];
        const encargoAfectado = encargos.find(({ uuid: encargoUUID }) => encargoUUID == uuid);
        encargoAfectado.erroresFormulario = {
          ...encargoAfectado.erroresFormulario,
          ...erroresFormulario,
        };
      });
      return draft;
    }
    default:
      return draft;
  }
});
